// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__5m7pr","fullScreen":"style_fullScreen__6P5IX","hidden":"style_hidden__23ivk"};